export default __webpack_public_path__ + "static/media/icon9.b3150b0a.png";